import React, { Component } from 'react';
import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react';
import { Modal, Collapse, Alert } from 'react-bootstrap';
import { withRouter } from "react-router-dom";
import _ from 'lodash';

import config from 'react-global-configuration';

import ChooseParticipants from './ChooseParticipants'
import ConfirmBooking from './ConfirmBooking'
import BookingSuccess from './BookingSuccess'

import { ImageSection, ModalHeading } from '../../GeneralStyle'

import ReactGA from "react-ga";

@inject('bookingStore')

@observer
class BookingModal extends Component {


  constructor(props) {
    super(props)
    this.state = {
      showModal: this.props.showModal,
      showAlert: true
    }

    this.closeModal = this.closeModal.bind(this)
  }

  componentDidMount() {
    this.props.onRef(this)
  }
  componentWillUnmount() {
    this.props.onRef(undefined)
  }

  openModal() {
    ReactGA.event({
      category: 'Booking',
      action: 'Click',
      label: 'Open - Booking Modal'
    });
    this.setState({ showModal: true });
  }

  closeModal() {
    ReactGA.event({
      category: 'Booking',
      action: 'Click',
      label: 'Close - Booking Modal'
    });
    this.setState({ showModal: false })

    if (this.props.bookingStore.screenNumber === 3 || this.props.bookingStore.isBookingModalError) {
      this.props.bookingStore.resetFutureBooking()
    }

    if (this.props.bookingStore.screenNumber > 1) {
      this.props.bookingStore.setScreenNumber(1)
    }
    this.props.bookingStore.setDate(null)
  }

  render() {
    const {
      isGolfCourse,
      golfCourse,
      screenNumber,
      isBookingModalError,
      bookingModalError
    } = this.props.bookingStore

    const modalSize = "md"
    return (
      <div>
        {isGolfCourse &&
          <Modal show={this.state.showModal} onHide={this.closeModal} bsSize={modalSize}>
            <ImageSection background={config.get('CLOUDINARY_URL') + golfCourse.calendarPicture + ".jpg"}>
              <Modal.Header closeButton>
                <Modal.Title>
                  <div>
                    <ModalHeading>
                      Ihre Buchung im {golfCourse.courseName}
                    </ModalHeading>
                  </div>
                </Modal.Title>
              </Modal.Header>
            </ImageSection>
            <Modal.Body style={{ paddingTop: 0 }}>

              <Collapse in={isBookingModalError} style={{ marginTop: 15 }}>
                <Alert bsStyle="danger" onDismiss={this.handleAlertDismiss}>
                  <p>{bookingModalError}</p>
                </Alert>
              </Collapse>

              {screenNumber === 1
                && <ChooseParticipants />}

              {screenNumber === 2
                && <ConfirmBooking closeModal={this.closeModal} closeDateModal={this.props.closeDateModal}/>}

              {screenNumber === 3
                && <BookingSuccess closeModal={this.closeModal} />}

            </Modal.Body>
          </Modal>}

      </div>
    );
  }
}

BookingModal.propTypes = {
  bookingStore: MobxPropTypes.observableObject
};

export default withRouter(BookingModal);



// WEBPACK FOOTER //
// /src/components/internal/BookingModal/BookingModal.js